import { useMemo } from 'react';
import { Ic } from './Icon';

interface PasswordRule {
  label: string;
  ok: boolean;
}

export function usePasswordRules(password: string) {
  return useMemo(() => {
    const rules: PasswordRule[] = [
      { label: 'Co najmniej 12 znaków', ok: password.length >= 12 },
      { label: 'Duża i mała litera', ok: /[a-z]/.test(password) && /[A-Z]/.test(password) },
      { label: 'Przynajmniej jedna cyfra', ok: /\d/.test(password) },
      { label: 'Przynajmniej jeden znak specjalny (!@#$…)', ok: /[^A-Za-z0-9]/.test(password) },
    ];
    const strength = rules.filter((r) => r.ok).length;
    return { rules, strength, allValid: strength === rules.length };
  }, [password]);
}

const STRENGTH_COLORS = ['#d0463c', '#d0463c', '#f4b93a', '#f4b93a', '#1f9d55'];
const STRENGTH_LABELS = ['Za słabe', 'Słabe', 'Średnie', 'Dobre', 'Mocne'];

export function PasswordStrengthMeter({ password }: { password: string }) {
  const { rules, strength } = usePasswordRules(password);
  const color = STRENGTH_COLORS[strength];
  const label = STRENGTH_LABELS[strength];

  return (
    <div>
      <div style={{ display: 'flex', gap: 4, marginTop: 10 }}>
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: 4,
              borderRadius: 2,
              background: strength > i ? color : 'rgba(15,30,61,.08)',
              transition: 'background .2s',
            }}
          />
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5, color: '#5b6578', marginTop: 6 }}>
        <span>Siła hasła</span>
        <span style={{ color, fontWeight: 600 }}>{label}</span>
      </div>

      <div
        style={{
          marginTop: 14,
          padding: 14,
          background: '#f7f6f2',
          borderRadius: 10,
          border: '1px solid rgba(15,30,61,.05)',
        }}
      >
        <div style={{ fontSize: 10.5, color: '#5b6578', fontWeight: 600, letterSpacing: '.06em', marginBottom: 8 }}>
          WYMAGANIA
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {rules.map((r, i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: 12.5,
                color: r.ok ? '#0f6b34' : '#5b6578',
              }}
            >
              <div
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 8,
                  flexShrink: 0,
                  background: r.ok ? '#1f9d55' : '#fff',
                  border: r.ok ? 'none' : '1.5px solid rgba(15,30,61,.18)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                }}
              >
                {r.ok && <Ic.check size={10} />}
              </div>
              <span>{r.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
